import { useNotificationStore } from "@/store/notification-store";

export function useNotifications() {
  const { notifications, unreadCount, addNotification, markAsRead, markAllAsRead, removeNotification, clearAll } = useNotificationStore();

  return {
    notifications,
    unreadCount,
    addNotification,
    markAsRead,
    markAllAsRead,
    removeNotification,
    clearAll,
  };
}
